import { Col, Container, Row } from "react-bootstrap";
import "./OurCoreValues.scss";
import integrity from "../../assets/images/integrity.png";
import excellence from "../../assets/images/excellence.png";
import customer from "../../assets/images/customer.png";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.2, ease: "easeOut" }
  })
};

const OurCoreValues = () => {
  const { t } = useTranslation(["translation", "de"]);
  return (
    <Container className="our-core-values">
      <Row className="our-core-values-title-body">
        <Col>
          <motion.span
            className="coreValue-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {t('coreValue.title')}
          </motion.span>
        </Col>
        <Col>
          <motion.span
            className="coreValue-subtitle"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            {t('coreValue.subtitle')}
          </motion.span>
        </Col>
      </Row>
      <Row className="our-core-values-body">
        {[
          { img: integrity, titleKey: 'coreValue.value1.title', subtitleKey: 'coreValue.value1.subtitle' },
          { img: customer, titleKey: 'coreValue.value2.title', subtitleKey: 'coreValue.value2.subtitle' },
          { img: excellence, titleKey: 'coreValue.value4.title', subtitleKey: 'coreValue.value4.subtitle' },
        ].map((item, index) => (
          <Col
            key={index}
            as={motion.div}
            custom={index}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="our-core-values-content"
            sm={3}
          >
            <img className="w-100 core-value-img" src={item.img} alt={t(item.titleKey) || ''} />
            <div className="our-core-text-body">
              <span className="our-core-text-title">{t(item.titleKey)}</span>
              <span className="our-core-text-subtitle">{t(item.subtitleKey)}</span>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default OurCoreValues;
